import { useEffect, useState } from "react";
import CheckboxWLabel from "../../../components/checkbox/checkboxwlabel/CheckboxWLabel";
import Heading from "../../../components/heading/Heading";
import { HEADING } from "../../../components/heading/constants/constants";
import Icons from "../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../components/icons/constants";
import Pagination from "../../../components/richgrid/Pagination";
import styles from "./PayerList.styles"
import { ROW_SELECTION_OPTIONS } from "../../../components/richgrid/constants";
import VerticalSeparator from "../../../components/separator/verticalseparator/VerticalSeparator";
import { useDispatch, useSelector } from "react-redux";
import { componentKey, setActivateConfirmationModalOpen, setDeActivateConfirmationModalOpen, setGenerateReportDrawer, setGenerateReportStates, setHighlightedPayer, setPaginationState, setSearchOption, setSelectedPayers, setSelectedReportsHeader, setShouldLoadPaginatedPayersList, setShowAssignToUserTable, toggleReportsHeader, toggleSelectedPayer } from './PayerListSlice'
import { activatePayer, deActivatePayer, deletePayer, downloadPayerReport, getFormAndRecipientStatus, getHeadersForPayerReport, getPaginatedPayersList, getPayersList } from "./PayerListSaga";
import PayerCard from "./payercard/PayerCard";
import Loadable from "../../../components/loadable/Loadable";
import { PAGE_STATE } from "../../constants/constants";
import PayerInformation from "./payerinformation/PayerInformation";
import MultiSelectActionCard from "./multiselectactioncard/MultiSelectActionCard";
import ConfirmationPopup from "../../../components/popup/confirmationpopup/ConfirmationPopup";
import { BUTTON_TYPE } from "../../../components/button/constants";
import { setDeleteConfirmationModalOpen } from "./PayerListSlice";
import GenerateReportDrawer from "./generatereportdrawer/GenerateReportDrawer";
import Popup from "../../../components/popup/Popup";
import TextInput from "../../../components/input/textinput/TextInput";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import Button from "../../../components/button/Button";
import { PAYER_SECTION_ROUTES } from "../constants";
import { ShowForAllowedPermissionsOnly } from "../../wrappers/ShowForAllowedPermissionsOnly";
import { PAGE_PATH, PAGE_PERMISSIONS } from "../../dashboard/constants/constant";
import { isAccessAllowed, PermissionReroute, useUserPermissionsInfo } from "../../dashboard/hooks/userHooks";
import { QUERY_PARAMS } from "../../formssection/constants";
import AssignMembersTable from "../../../businesslogic/components/addpayernew/assignmembers/assignmemberstable/AssignMembersTable"
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import useTxSearchParams from "../../../../libs/txsearchparams/TxSearchParamsHook";
import useTxNavigate from "../../../../libs/txnavigate/TxNavigateHook";
import { PAYER_LIST_LOADING_STATES, PAYER_LIST_MESSAGE_MAP } from "./Constants";
import DateUtils from "../../../../libs/utility/DateUtils";
import { TOASTER_VARIANT } from "../../../components/toast/constants";

export default function PayerList() {

    useGarbageCollector(componentKey)
    const navigate = useTxNavigate()

    const [queryParams, setQueryParams] = useTxSearchParams();

    const dispatch = useDispatch()
    const { payersList, selectedPayers, highlightedPayer,
        loadingState, deActivateConfirmationModalOpen, activateConfirmationModalOpen, deleteConfirmationModalOpen, paginationState,
        showGenerateReportDrawer, showAssginToUserTable, reportsHeaders, generateReportStates, searchOption, shouldLoadPaginatedPayersList } = useSelector((state) => state[componentKey]);
    const { permissions } = useUserPermissionsInfo();

    useEffect(() => {
        handleGetPaginatedPayersList(false, paginationState.PageNumber, paginationState.Skip, paginationState.PageSize, paginationState.IsDesc);
        dispatch(getHeadersForPayerReport())
    }, []);

    useEffect(() => {
        PermissionReroute(PAGE_PERMISSIONS.VIEW_PAYER, permissions, navigate, PAGE_PATH.DASHBOARD)
    }, [permissions])

    useEffect(() => {
        const urlPayerId = queryParams?.get(QUERY_PARAMS.PAYER_ID)
        const urlPayerName = queryParams?.get(QUERY_PARAMS.PAYER_NAME)
        
        if (!urlPayerId && !urlPayerName) return

        handleGetPaginatedPayersList(true, paginationState.PageNumber, paginationState.Skip, paginationState.PageSize, paginationState?.IsDesc, urlPayerName, urlPayerId);
    }, []);

    useEffect(() => {
        if (highlightedPayer?.PayerDetailId) {
            dispatch(getFormAndRecipientStatus(highlightedPayer))
        }
    }, [highlightedPayer])

    useEffect(() =>{
        if(shouldLoadPaginatedPayersList){
            handleGetPaginatedPayersList(false, paginationState.PageNumber, paginationState.Skip, paginationState.PageSize, paginationState?.IsDesc);
            dispatch(setShouldLoadPaginatedPayersList(false));
        }
    }, [shouldLoadPaginatedPayersList])

    const handleGetPaginatedPayersList = (updatePagination = false, pageNumber, skip, pageSize, isDesc, filterText = paginationState?.FilterText, idNumber = paginationState?.IdNumber ) => {
        dispatch(getPaginatedPayersList({ 
            ...paginationState, 
            PageNumber: pageNumber,
            PageSize: pageSize, 
            Skip: skip,
            IsDesc: isDesc,
            FilterText: filterText,
            IdNumber: idNumber,
            selectedPayers: selectedPayers,
            highlightedPayer: highlightedPayer,
        }))
        
        if(updatePagination){
            dispatch(setPaginationState({ 
                PageNumber: pageNumber,
                PageSize: pageSize, 
                Skip: skip,
                IsDesc: isDesc,
                FilterText: filterText,
                IdNumber: idNumber,
             }))
        }
    }

    const handleFilterInputSearch = (inputFieldName, e = null) => {
        if(e === null || e.key === "Enter"){
            handleGetPaginatedPayersList(true, 1, 0, paginationState.PageSize, paginationState?.IsDesc);
            const queryParamName = inputFieldName === 'FilterText' ? QUERY_PARAMS.PAYER_NAME : QUERY_PARAMS.PAYER_ID;
            if (paginationState[inputFieldName]) {
                queryParams.set(queryParamName, paginationState[inputFieldName])
            } else {
                queryParams.delete(queryParamName)
            }
    
            setQueryParams(queryParams)
        }
    }

    return (
        <>
            <Loadable currentState={loadingState.state} loadingStates={[PAYER_LIST_LOADING_STATES.GET_PAYER_LIST_LOADING]} isNewLoadable={true} messageMap={PAYER_LIST_MESSAGE_MAP} >

                    <div style={styles.headerContainer}>

                        <div>
                            <div style={styles.titleAndSearch}>
                                <Heading type={HEADING.H1}>Payer listing - you have added {paginationState?.totalPayers} payers so far</Heading>

                                <div style={styles.icons}>
                                    <div style={styles.searchContainer}>
                                        <TextInput
                                            label='Search by Name'
                                            placeHolder='Enter payer name'
                                            suffixProps={{
                                                icon: VEC_ICON_NAME.SEARCH_ICON,
                                                suffixIconCb: () => {
                                                    handleFilterInputSearch("FilterText")
                                                }
                                            }}
                                            value={paginationState?.FilterText}
                                            onChangeCb={(e) => dispatch(setPaginationState({ FilterText: e.target.value }))}
                                            onKeyDownCb={(e) => handleFilterInputSearch("FilterText", e)}
                                        />
                                    </div>
                                    <div style={styles.searchContainer}>
                                        <TextInput
                                            label='Search by Tax ID'
                                            value={paginationState?.IdNumber}
                                            placeHolder="Enter tax ID"
                                            type="text"
                                            onChangeCb={(e) => dispatch(setPaginationState({ IdNumber: e.target.value }))}
                                            suffixProps={{
                                                icon: VEC_ICON_NAME.SEARCH_ICON,
                                                suffixIconCb: () => {
                                                    handleFilterInputSearch("IdNumber")
                                                }
                                            }}
                                            onKeyDownCb={(e) => handleFilterInputSearch("IdNumber", e)}
                                        />
                                    </div>

                                    <VerticalSeparator />

                                    {/* <div >
                                        <Icons familyName='vec' iconName={VEC_ICON_NAME.FILTER_ICON} />
                                    </div> */}

                                    <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.CREATE_PAYERS}>
                                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} style={styles.button} prefixProps={{ icon: VEC_ICON_NAME.ADD_PAYER_ICON }} onClickCb={() => navigate(`/${PAYER_SECTION_ROUTES.PAYER}/${PAYER_SECTION_ROUTES.ADD}`)}>Add Payer</Button>
                                    </ShowForAllowedPermissionsOnly>
                                </div>
                            </div>
                        </div>

                        {payersList.length ?
                            <>
                                <div style={styles.selectAllAndSortActionContainer}>
                                    <div style={styles.selectAllCBox}>
                                        <CheckboxWLabel iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON} checked={selectedPayers?.length} label={selectedPayers?.length ? "Unselect All" : "Select All"} onChangeCb={(event) => dispatch(setSelectedPayers(selectedPayers?.length ? [] : payersList))} name="selectAll" />
                                    </div>

                                    <div style={styles.sortIcondiv} onClick={() => handleGetPaginatedPayersList(true, 1, 0, paginationState.PageSize, !paginationState?.IsDesc)}>
                                            <Icons familyName='vec' iconName={VEC_ICON_NAME.SORT_ICON} rotateDeg={paginationState?.IsDesc ? 0 : 180} />
                                    </div>
                                </div>

                                <div style={styles.mainContainer}>

                                    <div style={styles.cardContainer}>
                                        <div>
                                            {payersList.map((payer, idx) => (

                                                <PayerCard
                                                    key={`payer-card-${idx}`}
                                                    onChangeCheckboxCb={(e) => dispatch(toggleSelectedPayer({ payer, selectedPayers, isChecked: e.target.checked }))}
                                                    isSelected={selectedPayers.find(selectedRow => selectedRow.PayerDetailId == payer?.PayerDetailId)}
                                                    payer={payer}
                                                    isHighlighted={payer?.PayerDetailId === highlightedPayer?.PayerDetailId}
                                                    onCardClickCb={() => dispatch(setHighlightedPayer(payer))}
                                                />
                                            ))}
                                        </div>

                                        <div>
                                            <Pagination
                                                skip={paginationState?.Skip}
                                                take={paginationState?.PageSize}
                                                takeOptions={ROW_SELECTION_OPTIONS}
                                                onChangeTakeCb={(newTake) => {
                                                    handleGetPaginatedPayersList(true, 1, 0, newTake, paginationState?.IsDesc);
                                                }}
                                                total={paginationState?.totalPayers}
                                                onChange={(take, t) => {
                                                    handleGetPaginatedPayersList(true, Math.ceil((take + t) / take), t, paginationState.PageSize, paginationState?.IsDesc);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div style={styles.payerInformationContainer}>
                                        {
                                            selectedPayers.length ? <MultiSelectActionCard /> : <PayerInformation />
                                        }
                                    </div>

                                </div>
                            </>

                            :

                            loadingState.state === PAGE_STATE.PAGE_READY && <div style={styles.noPayersFoundContainer}>
                                <Heading type={HEADING.H2}>No Payers Found</Heading>
                            </div>
                        }

                    </div>

                {/* Activate / De-activate Confirmation Modal */}
                {deActivateConfirmationModalOpen && <ConfirmationPopup
                    isOpen={deActivateConfirmationModalOpen}
                    title={"Deactivate Payers"}
                    loadingState={loadingState}
                    loaderLoadingStates={[PAYER_LIST_LOADING_STATES.DEACTIVATE_PAYER_LOADING]}
                    loaderMessageMap={PAYER_LIST_MESSAGE_MAP}
                    bodyText={`Are you sure you want to deactivate the selected payers?`}
                    confirmationButtonProps={
                        {
                            onConfirmationCb: () => {
                                const activatedPayers = selectedPayers.filter((element) => element.IsActive === true)
                                dispatch(deActivatePayer({ highlightedPayer, selectedPayers: activatedPayers }))
                            },
                            confirmationButtonText: `Deactivate`,
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        }
                    }
                    cancelButtonProps={
                        {
                            onCancelCb: () => dispatch(setDeActivateConfirmationModalOpen(false)),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }
                    }
                />}

                {activateConfirmationModalOpen && <ConfirmationPopup
                    isOpen={activateConfirmationModalOpen}
                    title={"Activate Payers"}
                    loadingState={loadingState}
                    loaderLoadingStates={[PAYER_LIST_LOADING_STATES.ACTIVATE_PAYER_LOADING]}
                    loaderMessageMap={PAYER_LIST_MESSAGE_MAP}
                    bodyText={`Are you sure you want to activate the selected payers?`}
                    confirmationButtonProps={
                        {
                            onConfirmationCb: () => {
                                const deActivatedPayers = selectedPayers.filter((element) => element.IsActive === false);
                                dispatch(activatePayer({ highlightedPayer, selectedPayers: deActivatedPayers }))
                            },
                            confirmationButtonText: "Activate",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        }
                    }
                    cancelButtonProps={
                        {
                            onCancelCb: () => dispatch(setActivateConfirmationModalOpen(false)),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }
                    }
                />}

                {/* Delete Confirmation Modal */}
                {deleteConfirmationModalOpen && <ConfirmationPopup
                    isOpen={deleteConfirmationModalOpen}
                    title="Delete Payers"
                    loadingState={loadingState}
                    loaderLoadingStates={[PAYER_LIST_LOADING_STATES.DELETE_PAYER_LOADING]}
                    loaderMessageMap={PAYER_LIST_MESSAGE_MAP}
                    bodyText="Are you sure you want to delete the selected payer?"
                    confirmationButtonProps={
                        {
                            onConfirmationCb: () => {
                                dispatch(deletePayer({ highlightedPayer, selectedPayers }))
                            },
                            confirmationButtonText: "Delete",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.DANGER,
                        }
                    }
                    cancelButtonProps={
                        {
                            onCancelCb: () => dispatch(setDeleteConfirmationModalOpen(false)),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }
                    }
                />}

                {/* Generate Report Drawer */}
                {showGenerateReportDrawer && <GenerateReportDrawer
                    isOpen={showGenerateReportDrawer}
                    title={"Generate report"}
                    onCloseCb={() => {
                        dispatch(setGenerateReportDrawer(!showGenerateReportDrawer))
                        dispatch(setGenerateReportStates({ fromDate: "", toDate: "", extension: "" }))
                        dispatch(toggleReportsHeader({ isChecked: false, reportsHeaders }))
                    }}
                    backButtonProp={{
                        backCb: () => {
                            dispatch(setGenerateReportDrawer(!showGenerateReportDrawer))
                        },
                        text: "Close",
                    }}
                    submitButtonProp={{
                        submitCb: () => {
                            if (generateReportStates.fromDate.length == 0 || generateReportStates.toDate.length == 0 || generateReportStates.extension.length == 0) {
                                dispatch(addNotifications({ heading: "Please enter all required information.", message: "Please provide the from, to dates and extension . Choose the report headings.", variant: TOASTER_VARIANT.WARNING }));
                                return
                            }

                            const data = {
                                reportsHeaders: reportsHeaders,
                                generateReportStates: generateReportStates,
                                payers: selectedPayers.length < 1 ? [highlightedPayer] : selectedPayers
                            }

                            dispatch(downloadPayerReport(data))
                        },
                        currentState: loadingState.state,
                        loadingStates: [PAYER_LIST_LOADING_STATES.DOWNLOAD_PAYER_REPORT_LOADING],
                        text: "Export",
                    }}
                    reportsHeaders={reportsHeaders}
                    optionalInformation={generateReportStates}
                    onChangeSelectAllCb={(event) => dispatch(toggleReportsHeader({ isChecked: event.target.checked, reportsHeaders }))}
                    onChangeReportHeadersCb={(event, idx) => dispatch(setSelectedReportsHeader({ index: idx, isChecked: event.target.checked }))}
                    onChangeCalendarInputCb={(event) => dispatch(setGenerateReportStates({ [event.target.name]: event.target.value }))}
                    onChangeFileFormatCb={(event) => dispatch(setGenerateReportStates({ [event.target.name]: event.target.value }))}
                />}

                {showAssginToUserTable && <AssignMembersTable
                    isPopup={true}
                    isPopupOpen={showAssginToUserTable}
                    selectedPayersList={selectedPayers}
                    payerDetails={highlightedPayer}
                    title={"Assign Payer to Other Users"}
                    onPopupCloseCb={() => dispatch(setShowAssignToUserTable(false))}
                />}

            </Loadable>
        </>
    )
}
